<page-load-header *ngIf="!initialized"></page-load-header>

<div class="bg-light vh-100" style="margin-left: -15px; margin-right: -15px">
  <div class="jumbotron d-flex align-items-center" style="min-height: 50vh">
    <div class="container text-center">
      <div *ngIf="initialized" class="container">
        <form class="form">
          <div *ngIf="stage == 0 && !conference.callForPapersOpen && !editExisting && !bypassDeadline">
            <h2>Call For Abstracts</h2>
            <h3>Submission deadline has passed</h3>
          </div>
          <div *ngIf="stage == 0 && (conference.callForPapersOpen || editExisting || bypassDeadline)">
            <div class="form-group">
              <h2>Call For Abstracts</h2>
              <div *ngIf="conference.callForPaperInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="conference.callForPaperInstructions | safeHtml"></div>
              <h4>What kind of abstract would you like to submit?</h4>
              <select class="form-control-lg" [(ngModel)]="model.paperTypeId" name="paperType" style="width: 500px">
                <option *ngFor="let type of paperTypes" [value]="type.id">{{ type.name }}</option>
              </select>
            </div>
            <button [disabled]="!model.paperTypeId" type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
          </div>

          <div *ngIf="stage == 1">
            <div *ngIf="paperType.screenLoginInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenLoginInstructions | safeHtml"></div>
            <div *ngIf="!auth.isLoggedIn()" class="">
              <h4>You not are logged in.</h4>
              <p>Please login or create an account to track this submission and future correspondence.</p>
              <button type="button" (click)="goToStage(0)" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" class="btn btn-primary" (click)="navService.showLogin()">Login/Sign-Up</button>
            </div>
            <div *ngIf="auth.isLoggedIn()">
              <div class="alert alert-heading">
                <img class="img-fluid rounded-circle" [fallback]="'fetch-avatar?userId=' + auth.user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ auth.user.id }}-avatar.png" />
                <h4>You are logged in as {{ auth.user.firstName + ' ' + auth.user.lastName }}</h4>
                <p>All future correspondence will be tied to this account.</p>
                <a href="#">Login with a different account</a>
              </div>
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
            </div>
          </div>

          <div *ngIf="stage == 2">
            <div class="form-group">
              <h4>{{ paperType.title }} Information</h4>
              <div *ngIf="paperType.screenGeneralInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenGeneralInstructions | safeHtml"></div>
              <div class="text-left mt-5">
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <label for="firstName">{{ paperType.title }} Title</label>
                    <input type="text" [(ngModel)]="model.title" maxlength="1000" name="title" class="form-control" />
                    <div class="invalid-message">
                      <div>Title is required</div>
                    </div>
                  </div>
                  <div *ngIf="paperType.askForShortTitle" class="col-md-6 mb-5">
                    <div class="d-flex justify-content-between">
                      <label for="firstName">Short Title (40 characters)</label>
                      <small>{{ 0 + model.shortTitle?.length }}/40</small>
                    </div>
                    <input type="text" [(ngModel)]="model.shortTitle" maxlength="40" name="shortTitle" class="form-control" />
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div *ngIf="paperType.askForContentArea" class="col-md-6 mb-5">
                    <label for="firstName">Primary Content Area</label>
                    <select id="inputState" [(ngModel)]="model.contentArea" name="contentArea" class="form-control">
                      <option selected>Choose...</option>
                      <option [value]="'AB'">Animal Behavior (AB)</option>
                      <option [value]="'AUT'">Autism (AUT)</option>
                      <option [value]="'BIR'">Brain Injury Rehabilitation (BIR)</option>
                      <option [value]="'BPL'">Business Practices/Leadership (BPL)</option>
                      <option [value]="'CA'">Community Applications (CA)</option>
                      <option [value]="'CUL'">Culture/Diversity (CUL)</option>
                      <option [value]="'DD'">Developmental Disabilities (DD)</option>
                      <option [value]="'DPP'">Dissemination/Public Policy (DPP)</option>
                      <option [value]="'ES'">Education /Schools (ES)</option>
                      <option [value]="'EVS'">Environmental Sustainability (EVS)</option>
                      <option [value]="'ETH'">Ethics (ETH)</option>
                      <option [value]="'GER'">Gerontology (GER)</option>
                      <option [value]="'HF'">Health, Fitness & Sports (HF)</option>
                      <option [value]="'MH'">Mental Health (MH)</option>
                      <option [value]="'OBM'">Organizational Behavior Management (OBM)</option>
                      <option [value]="'OAS'">Other ABA Service (OAS)</option>
                      <option [value]="'PED'">Pediatric (PED)</option>
                      <option [value]="'PH'">Public Health (PH)</option>
                      <option [value]="'PRO'">Professional (PRO)</option>
                      <option [value]="'SUD'">Substance Use Disorders (SUD)</option>
                      <option [value]="'TCP'">Theoretical/Conceptual/Philosophical</option>
                      <option [value]="'TTS'">Teaching/Training/Supervision (TTS)</option>
                      <option [value]="'VB'">Verbal Behavior (VB)</option>
                    </select>
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div *ngIf="paperType.askForCustomContentArea && paperType.customContentAreas.length > 0" class="col-md-12 mb-5">
                    <label for="firstName">Presentation Category (Choose up to 3)</label>
                    <kendo-multiselect [data]="paperType.customContentAreas" [(ngModel)]="model.customContentAreas" [name]="'customContentAreas'" [valuePrimitive]="true" textField="text" valueField="text" [placeholder]="'Click here to choose'" [allowCustom]="false"> </kendo-multiselect>

                    <!-- <select id="inputState" [(ngModel)]="model.contentArea" name="contentArea" class="form-control">
                      <option selected>Choose...</option>
                      <option *ngFor="let ca of paperType.customContentAreas" [value]="ca.id">{{ca.text}}</option>

                    </select> -->
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div *ngIf="paperType.askDuration" class="col-md-6 mb-5">
                    <label for="firstName">What is the anticipated duration of this {{ paperType.title }}?</label>
                    <select id="inputState" [(ngModel)]="model.anticipatedDurationMins" name="anticipatedDurationMins" class="form-control">
                      <option selected>Choose...</option>
                      <option *ngFor="let item of paperType.availibleDurations" [value]="item">{{ item }} Minutes</option>
                    </select>
                    <div class="invalid-message">
                      <div>Duration is required</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div *ngIf="paperType.askForAbstract" class="col-md-12 mb-5">
                    <label for="firstName">Abstract</label>
                    <textarea class="form-control" [(ngModel)]="model.abstract" name="abstract"></textarea>
                  </div>
                  <ng-container *ngIf="paperType.askForLearningObjectives">
                    <div class="col-md-12 mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="firstName">Learning Objective 1</label>
                        <small>{{ 0 + model.learningObjective1?.length }}/500</small>
                      </div>

                      <textarea class="form-control" [(ngModel)]="model.learningObjective1" placeholder="Participants will..." maxlength="500" name="learningObjective1"></textarea>
                    </div>
                    <div class="col-md-12 mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="firstName">Learning Objective 2</label>
                        <small>{{ 0 + model.learningObjective2?.length }}/500</small>
                      </div>
                      <textarea class="form-control" [(ngModel)]="model.learningObjective2" placeholder="Participants will..." maxlength="500" name="learningObjective2"></textarea>
                    </div>
                    <div class="col-md-12 mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="firstName">Learning Objective 3</label>
                        <small>{{ 0 + model.learningObjective3?.length }}/500</small>
                      </div>
                      <textarea class="form-control" [(ngModel)]="model.learningObjective3" placeholder="Participants will..." maxlength="500" name="learningObjective3"></textarea>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="paperType.askForData">
                    <div class="col-md-6 mb-5">
                      <label for="firstName">Do you have supporting data?</label>
                      <select id="inputState" [(ngModel)]="model.hasSupportingData" name="hasSupportingData" class="form-control">
                        <option [ngValue]="null" selected>Choose...</option>
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                    </div>
                    <div *ngIf="model.hasSupportingData == true" class="col-md-6 mb-5">
                      <label for="firstName">Upload Supporting Data </label>
                      <div *ngIf="model.dataAssetPath">
                        <div class="input-group mb-3">
                          <input type="text" readonly [value]="model.dataAssetPath.slice(36)" class="form-control" />
                          <div class="input-group-append">
                            <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="this.model.dataAssetPath = null">
                              <span class="fas fa-trash btn-icon__inner"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <kendo-upload class="form-control" *ngIf="!model.dataAssetPath" [saveUrl]="cvUploadUrl" [multiple]="false" (success)="dataAssetSuccessEventHandler($event)"></kendo-upload>
                    </div>
                    <div *ngIf="model.hasSupportingData == false" class="col-md-12 mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="firstName">Please give a reason for not having data.</label>
                        <small>{{ 0 + model.dataNullReason?.length }}/1000</small>
                      </div>
                      <textarea class="form-control" [(ngModel)]="model.dataNullReason" placeholder="I don't have data because..." maxlength="1000" name="dataNullReason"></textarea>
                    </div>
                  </ng-container>
                  <div *ngIf="paperType.askForSpecialRequests" class="col-md-12 mb-5">
                    <div class="d-flex justify-content-between">
                      <label for="firstName">Do you have any special requests or other considerations related to your presentation?</label>
                      <small>{{ 0 + model.specialRequests?.length }}/1000</small>
                    </div>
                    <textarea class="form-control" maxlength="1000" [(ngModel)]="model.specialRequests" name="specialRequests"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
            <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
          </div>
          <div *ngIf="stage == 3">
            <div class="form-group">
              <h4>CEU Information</h4>
              <div *ngIf="paperType.screenCEUInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenCEUInstructions | safeHtml"></div>
              <div class="text-left mt-5">
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <label for="firstName">Will this presentation meet the BACB's CEU requirements? </label>
                    <select id="inputState" [(ngModel)]="model.meetsCEURequirements" name="meetsCEURequirements" class="form-control">
                      <option [ngValue]="null" selected>Choose...</option>
                      <option [value]="'Yes'">Yes, BACB CEUs should be offered for this presentation</option>
                      <option [value]="'No'">No, this presentation is not for CEU credit</option>
                      <option [value]="'Unsure'">Maybe/I'm not sure</option>
                    </select>
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-5">
                    <label for="firstName">Will this presentation be eligible for Supervision CEUs?</label>
                    <select id="inputState" [(ngModel)]="model.meetsSupervisionCEURequirements" name="meetsSupervisionCEURequirements" class="form-control">
                      <option [ngValue]="null" selected>Choose...</option>
                      <option [value]="'Yes'">Yes, this presentation meets the BACB's SUP requirements</option>
                      <option [value]="'No'">No, this is not a Supervision presentation</option>
                      <option [value]="'Unsure'">Maybe/I'm not sure</option>
                    </select>
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-5">
                    <label for="firstName">Will this presentation be eligible for Ethics CEUs?</label>
                    <select id="inputState" [(ngModel)]="model.meetsEthicsCEURequirements" name="meetsEthicsCEURequirements" class="form-control">
                      <option [ngValue]="null" selected>Choose...</option>
                      <option [value]="'Yes'">Yes, this presentation meets the BACB's ETH requirements</option>
                      <option [value]="'No'">No, this is not an Ethics presentation</option>
                      <option [value]="'Unsure'">Maybe/I'm not sure</option>
                    </select>
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div *ngIf="paperType.askForAPACEUInfo" class="col-md-6 mb-5">
                    <label for="firstName">Will this presentation meet the APA's CEU requirements? </label>
                    <select id="inputState" [(ngModel)]="model.meetsAPACEURequirements" name="meetsAPACEURequirements" class="form-control">
                      <option [ngValue]="null" selected>Choose...</option>
                      <option [value]="'Yes'">Yes, APA CEUs should be offered for this presentation</option>
                      <option [value]="'No'">No, this presentation is not for APA CEU credit</option>
                      <option [value]="'Unsure'">Maybe/I'm not sure</option>
                    </select>
                    <div class="invalid-message">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-5">
                    <label for="firstName">Who is the CEU Instructor for this {{ paperType.title }}?</label>
                    <input type="text" [(ngModel)]="model.ceuInstructorName" name="ceuInstructorName" class="form-control" />
                  </div>
                  <div class="col-md-6 mb-5">
                    <label for="firstName">What is the CEU Instructor's certification number?</label>
                    <input type="text" [(ngModel)]="model.ceuInstructorBACBNumber" name="ceuInstructorBACBNumber" class="form-control" />
                  </div>

                  <div class="col-md-6 mb-5">
                    <label for="firstName">CEU Instructor's CV</label>
                    <div *ngIf="model.cvAssetPath">
                      <div class="input-group mb-3">
                        <input type="text" readonly [value]="model.cvAssetPath.slice(36)" class="form-control" />
                        <div class="input-group-append">
                          <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="this.model.cvAssetPath = null">
                            <span class="fas fa-trash btn-icon__inner"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <kendo-upload class="form-control" *ngIf="!model.cvAssetPath" [saveUrl]="cvUploadUrl" [multiple]="false" (success)="successEventHandler($event)"></kendo-upload>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
            <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
          </div>

          <div *ngIf="stage == 4">
            <h4>Manage People</h4>
            <div *ngIf="paperType.screenPeopleInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenPeopleInstructions | safeHtml"></div>
            <h5>Manage people associated with this {{ paperType.title }}</h5>
            <div *ngIf="paperType.askForPrimarySpeaker" class="row no-gutters no-candidates mb-2" style="min-height: 100px">
              <div class="col-sm-12 my-auto">
                <h4>Presenter(s)</h4>
                <ng-container *ngFor="let panelist of model.presenters" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: panelist, role: 'Presenter' }"></ng-container>
                <div class="mt-2 mb-2">
                  <button type="button" (click)="addPerson('Presenter', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                  <button type="button" (click)="addPerson('Presenter', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForDiscussant" class="row no-gutters no-candidates mb-2 p-2" style="min-height: 100px">
              <div class="col-sm-12 my-auto">
                <h4>Discussant</h4>
                <p class="text-muted text-left">During the event, a discussant will help the audience better understand the papers presented by serving as a commentator on them and the issues concerning them. They'll also give presenters feedback to help them move their research forward.</p>
                <ng-container *ngIf="model.discussant" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: model.discussant, role: 'Discussant' }"></ng-container>

                <div class="mt-2 mb-2" *ngIf="!model.discussant">
                  <button type="button" (click)="addPerson('Discussant', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                  <button type="button" (click)="addPerson('Discussant', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForChair" class="row no-gutters no-candidates mb-2 p-2" style="min-height: 100px">
              <div class="col-sm-12 my-auto">
                <h4>Chair</h4>
                <p class="text-muted text-left">The function of a session chair is to lead the session—you will introduce the session and the presenters, keep the session moving according to a prearranged schedule, and you must do this in a courteous and professional manner.</p>
                <ng-container *ngIf="model.chair" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: model.chair, role: 'Chair' }"></ng-container>

                <div class="mt-2 mb-2" *ngIf="!model.chair">
                  <button type="button" (click)="addPerson('Chair', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                  <button type="button" (click)="addPerson('Chair', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForPanelists" class="row no-gutters no-candidates mb-2" style="min-height: 100px">
              <div class="col-sm-12 my-auto">
                <h4>Panelists</h4>
                <ng-container *ngFor="let panelist of model.panelists" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: panelist, role: 'Panelist' }"></ng-container>

                <div class="mt-2 mb-2">
                  <button type="button" (click)="addPerson('Panelist', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                  <button type="button" (click)="addPerson('Panelist', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForAuthors" class="row no-gutters no-candidates mb-2" style="min-height: 100px">
              <div class="col-sm-12 my-auto">
                <h4>Additional Authors</h4>
                <ng-container *ngFor="let panelist of model.authors" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: panelist, role: 'Author' }"></ng-container>

                <button type="button" (click)="addPerson('Author', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                <button type="button" (click)="addPerson('Author', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
              </div>
            </div>
            <div class="mt-2 mb-2">
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
            </div>
          </div>

          <div *ngIf="stage == 5">
            <h4>{{ paperType.title }} Papers</h4>
            <div *ngIf="paperType.screenChildPaperInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenChildPaperInstructions | safeHtml"></div>
            <div class="form-group">
              <div class="row no-gutters no-candidates" style="height: 300px">
                <div class="col-sm-12 my-auto">
                  <div *ngIf="!model.childPapers || model.childPapers.length == 0">
                    <h1><i class="fas fa-empty-set"></i></h1>
                    <h4>No Papers Yet</h4>
                  </div>
                  <ng-container *ngIf="model.childPapers && model.childPapers.length > 0">
                    <div *ngFor="let paper of model.childPapers" class="cfp-presenter-box">
                      <div class="d-flex">
                        <div class="d-flex align-items-center" style="min-height: 2rem">{{ paper.title }}<span *ngIf="!paper.title">untitled</span></div>
                      </div>
                      <div class="tools-overlay"></div>
                      <div class="tools">
                        <a href="javascript:void(0)" class="remove text-black" (click)="editPaper(paper)"><i class="fas fa-pencil"></i></a>
                        <a href="javascript:void(0)" class="remove" (click)="removePaper(paper)"><i class="fas fa-times"></i></a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- <ul class="list-group" *ngIf="model.childPapers && model.childPapers.length > 0">
                    <li class="list-group-item" *ngFor="let paper of model.childPapers">{{ paper.title }}<span *ngIf="!paper.title">untitled</span> <a class="ml-2 mr-2" (click)="editPaper(paper)" href="javascript:void(0)">Edit</a> <a (click)="removePaper(paper)" href="javascript:void(0)">Remove</a></li>
                  </ul> -->
                  <button type="button" class="btn btn-secondary mt-2" (click)="addPaper()">Add Paper</button>
                </div>
              </div>
            </div>
            <div class="mt-2 mb-2">
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
            </div>
          </div>

          <div *ngIf="stage == 6">
            <div class="form-group">
              <h4>Payment & Perks</h4>
              <div *ngIf="paperType.screenPaymentInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenPaymentInstructions | safeHtml"></div>
              <h5>Please fill out any missing information.</h5>
              <div class="text-left mt-5">
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <label for="firstName">Make Check out to:</label>
                    <input type="text" class="form-control" [(ngModel)]="model.checkName" name="checkName" id="inputAddress" placeholder="" />
                  </div>
                </div>

                <div class="form-group">
                  <label for="inputAddress">Address</label>
                  <input type="text" class="form-control" id="inputAddress" [(ngModel)]="model.address1" name="address1" placeholder="1234 Main St" />
                </div>
                <div class="form-group">
                  <label for="inputAddress2">Address 2</label>
                  <input type="text" class="form-control" id="inputAddress2" [(ngModel)]="model.address2" name="address2" placeholder="Apartment, studio, or floor" />
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">City</label>
                    <input type="text" class="form-control" [(ngModel)]="model.city" name="city" id="inputCity" />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputState">State</label>
                    <state-dropdown class="form-control" [(ngModel)]="model.state" name="state"></state-dropdown>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="inputZip">Zip</label>
                    <input type="text" class="form-control" [(ngModel)]="model.zip" name="zip" id="inputZip" />
                  </div>
                </div>
              </div>
            </div>
            <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
            <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
          </div>

          <div *ngIf="stage == 7">
            <div class="form-group">
              <h4>Additional Questions</h4>
              <div class="text-left mt-5">
                <div class="row">
                  <survey class="survey-embed" [model]="surveyModel"></survey>

                  <!-- <div *ngFor="let question of paperType.customQuestions; let idx = index" class="col-md-6 mb-5">
                    <label for="firstName">{{ question.text }}</label>
                    <kendo-multiselect *ngIf="question.allowMultipleAnswers" [data]="question.answers" textField="answer" [valuePrimitive]="true"  class="form-control" valueField="id"  ></kendo-multiselect>
                    <select *ngIf="!question.allowMultipleAnswers" id="inputState" [(ngModel)]="model.paperCustomQuestionResponses[idx]" [compareWith]="compareByID" [name]="'paperCustomQuestionResponses' + idx" class="form-control">
                      <option [ngValue]="null">Choose...</option>
                      <option *ngFor="let answer of question.answers" [ngValue]="answer">{{ answer.answer }}</option>
                    </select>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="text-center">
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
            </div>
          </div>

          <div class="text-left" *ngIf="stage == 8">
            <h3 class="text-left">In making this submission, I understand, affirm, and agree to the following:</h3>
            <div *ngIf="paperType.screenAcknowledgementInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenAcknowledgementInstructions | safeHtml"></div>

            <div class="acknowledgements d-flex mb-3" *ngFor="let ack of conference.paperAcknowledgements; let idx = index"><input class="mr-2" type="checkbox" [(ngModel)]="ack.checked" name="checked{{ idx }}" /> <span [innerHTML]="ack.text"></span></div>
            <div class="text-center">
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="nextStage()" class="btn btn-alternate">Continue <i class="fas fa-chevron-right"></i></button>
            </div>
          </div>

          <div class="text-left" *ngIf="stage == 9">
            <h3 class="text-center">Review Submission</h3>
            <div *ngIf="paperType.screenReviewInstructions" class="ckembed alert alert-white call-for-papers-notes text-left" [innerHTML]="paperType.screenReviewInstructions | safeHtml"></div>

            <div *ngIf="(model.errors && model.errors.length > 0) || !didAgree" class="alert alert-danger text-left">
              <h5>Please correct the following errors before submitting</h5>
              <ul>
                <li *ngFor="let error of model.errors">{{ error.error }} (<a href="javascript:void(0)" (click)="goToStage(error.step)">Fix</a>)</li>
                <li *ngIf="!didAgree">Please agree to all items in the acknowledgements. (<a href="javascript:void(0)" (click)="goToStage(8)">Fix</a>)</li>
              </ul>
            </div>

            <div class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Title:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.title }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForShortTitle" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Short Title:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.shortTitle }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForContentArea" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Content Area:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.contentArea }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForAbstract" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Abstract:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.abstract }}" />
              </div>
            </div>
            <ng-container *ngIf="paperType.askForLearningObjectives">
              <div class="row">
                <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Learning Objective 1:</strong></label>
                <div class="col-sm-9">
                  <input type="text" readonly class="form-control-plaintext" value="{{ model.learningObjective1 }}" />
                </div>
              </div>
              <div class="row">
                <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Learning Objective 2:</strong></label>
                <div class="col-sm-9">
                  <input type="text" readonly class="form-control-plaintext" value="{{ model.learningObjective2 }}" />
                </div>
              </div>
              <div class="row">
                <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Learning Objective 3:</strong></label>
                <div class="col-sm-9">
                  <input type="text" readonly class="form-control-plaintext" value="{{ model.learningObjective3 }}" />
                </div>
              </div>
            </ng-container>
            <div *ngIf="paperType.askDuration" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Duration:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.anticipatedDurationMins }} minutes" />
              </div>
            </div>

            <div class="row" *ngIf="paperType.askForCEUInfo">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Meet CEU Req:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.meetsCEURequirements }}" />
              </div>
            </div>

            <div class="row" *ngIf="paperType.askForCEUInfo">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Supervision CEU Req:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.meetsSupervisionCEURequirements }}" />
              </div>
            </div>
            <div class="row" *ngIf="paperType.askForCEUInfo">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Ethics CEU Req:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.meetsEthicsCEURequirements }}" />
              </div>
            </div>
            <div class="row" *ngIf="paperType.askForCEUInfo">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>CEU Instructor:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.ceuInstructorName }}" />
              </div>
            </div>
            <div class="row" *ngIf="paperType.askForCEUInfo">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>CEU Instructor CV:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.cvAssetPath?.slice(36) }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForChair" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Chair:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.chair?.fullNameWithCredentials }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForDiscussant" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Discussant:</strong></label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control-plaintext" value="{{ model.discussant?.fullNameWithCredentials }}" />
              </div>
            </div>
            <div *ngIf="paperType.askForPanelists" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Panelists:</strong></label>
              <div class="col-sm-9">
                <div class="form-control-plaintext">
                  <span *ngFor="let user of model.panelists">{{ user.fullNameWithCredentials }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForPrimarySpeaker" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Presenters:</strong></label>
              <div class="col-sm-9">
                <div class="form-control-plaintext">
                  <span *ngFor="let user of model.presenters">{{ user.fullNameWithCredentials }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="paperType.askForAuthors" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Authors:</strong></label>
              <div class="col-sm-9">
                <div class="form-control-plaintext">
                  <span *ngFor="let user of model.authors">{{ user.fullNameWithCredentials }}</span>
                </div>
              </div>
            </div>

            <div *ngIf="paperType.requiredPaperCount > 0" class="row">
              <label for="inputEmail3" class="col-sm-3 col-form-label"><strong>Papers:</strong></label>
              <div class="col-sm-9">
                <div class="form-control-plaintext" *ngFor="let paper of model.childPapers">
                  <span>{{ paper.title }} - {{ paper.presenter?.fullNameWithCredentials }}</span>
                </div>
              </div>
            </div>

            <div class="text-center mt-5">
              <button type="button" (click)="previousStage()" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Back</button>
              <button type="button" (click)="saveDraft()" class="btn btn-outline-dark mr-2">Save Draft</button>
              <button type="button" [disabled]="model.errors.length > 0 || !didAgree" (click)="submitPaper()" class="btn btn-alternate">Submit Paper</button>
            </div>
          </div>

          <div *ngIf="stage == 99">
            <div class="form-group">
              <h4>Add/Edit {{ paperType.title }} Paper</h4>
              <div class="text-left mt-5">
                <div class="row">
                  <div class="col-md-6 mb-5">
                    <label for="firstName">Paper Title</label>
                    <input [(ngModel)]="tempPaper.title" name="tempPaperTitle" type="text" class="form-control" />
                    <div class="invalid-message">
                      <div>Title is required</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-5">
                    <label for="firstName">Description</label>
                    <textarea [(ngModel)]="tempPaper.description" name="tempPaperDescription" class="form-control"></textarea>
                  </div>
                </div>
                <h3>Presenters & Authors</h3>
                <div class="row no-gutters no-candidates mb-2" style="min-height: 100px">
                  <div class="col-sm-12 my-auto">
                    <h4>Presenter</h4>
                    <ng-container *ngIf="tempPaper.presenter" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: tempPaper.presenter, role: 'ChildPresenter' }"></ng-container>

                    <div class="mt-2 mb-2" *ngIf="!tempPaper.presenter">
                      <button type="button" (click)="addPerson('ChildPresenter', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                      <button type="button" (click)="addPerson('ChildPresenter', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters no-candidates mb-2" style="min-height: 100px">
                  <div class="col-sm-12 my-auto">
                    <h4>Authors</h4>
                    <ng-container *ngFor="let author of tempPaper.authors" [ngTemplateOutlet]="presenterCard" [ngTemplateOutletContext]="{ person: author, role: 'ChildAuthor' }"></ng-container>

                    <div class="mt-2 mb-2">
                      <button type="button" (click)="addPerson('ChildAuthor', true)" class="btn btn-sm btn-outline-secondary mr-2">Add Myself</button>
                      <button type="button" (click)="addPerson('ChildAuthor', false)" class="btn btn-sm btn-outline-secondary">Add Someone Else</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" (click)="goToStage(5)" class="btn btn-outline-alternate mr-2"><i class="fas fa-chevron-left"></i> Cancel</button>
            <button type="button" (click)="savePaper()" class="btn btn-alternate">Save Paper <i class="fas fa-chevron-right"></i></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #presenterCard let-person="person" let-role="role">
  <div class="cfp-presenter-box">
    <div class="d-flex">
      <img class="img-fluid rounded-circle mr-2" [fallback]="'fetch-avatar?userId=' + person.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ person.id }}-avatar.png" />
      <div class="d-flex align-items-center">{{ person.fullNameWithCredentials }}</div>
    </div>
    <div class="tools-overlay"></div>
    <div class="tools">
      <a href="javascript:void(0)" class="remove text-black" (click)="editPerson(role, person.id)"><i class="fas fa-pencil"></i></a>
      <a href="javascript:void(0)" class="remove" (click)="removePerson(role, person.id)"><i class="fas fa-times"></i></a>
    </div>
  </div>
</ng-template>
